"use client";

import { IoClose } from "react-icons/io5";
import { MdKeyboardArrowDown } from "react-icons/md";

export type CreateAdminFormData = {
    username: string;
    password: string;
	firstname: string;
	lastname: string;
	role: "super_admin" | "admin";
	email: string;
};

type CreateAdminPopUpProps = {
	onClose: () => void;
	formData: CreateAdminFormData;
	onChange: (next: CreateAdminFormData) => void;
	onSave: () => void;
	isSaving?: boolean;
};

export default function CreateAdminPopUp({
	onClose,
	formData,
	onChange,
	onSave,
	isSaving = false,
}: CreateAdminPopUpProps) {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 p-4">
			<div className="w-full max-w-130 rounded-md bg-[#f3f3f3] p-4 shadow-[0_6px_20px_rgba(0,0,0,0.35)]">
				<div className="flex items-center justify-between">
					<h2 className="text-xl font-bold leading-none text-[#4e4e4e]">เพิ่มผู้ดูแลระบบ</h2>
					<button
						type="button"
						onClick={onClose}
						className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-[#d7dade] text-[#8d939a]"
					>
						<IoClose size={20} />
					</button>
				</div>

				<div className="mt-4 grid grid-cols-1 gap-3">

                    <div>
						<label className="block text-base font-semibold text-[#5a5a5a]">Username</label>
						<input
							type="text"
							value={formData.username}
							onChange={(event) =>
								onChange({
									...formData,
									username: event.target.value,
								})
							}
							className="mt-1 h-11 w-full rounded-sm border border-[#d5d5d5] bg-white px-3 text-base text-[#4E4E4E] outline-none"
							placeholder="กรอกชื่อผู้ใช้"
						/>
					</div>

                    <div>
						<label className="block text-base font-semibold text-[#5a5a5a]">Password</label>
						<input
							type="password"
							value={formData.password}
							onChange={(event) =>
								onChange({
									...formData,
									password: event.target.value,
								})
							}
							className="mt-1 h-11 w-full rounded-sm border border-[#d5d5d5] bg-white px-3 text-base text-[#4E4E4E] outline-none"
							placeholder="กรอกรหัสผ่าน"
						/>
					</div>

					<div>
						<label className="block text-base font-semibold text-[#5a5a5a]">Firstname</label>
						<input
							type="text"
							value={formData.firstname}
							onChange={(event) =>
								onChange({
									...formData,
									firstname: event.target.value,
								})
							}
							className="mt-1 h-11 w-full rounded-sm border border-[#d5d5d5] bg-white px-3 text-base text-[#4E4E4E] outline-none"
							placeholder="กรอกชื่อ"
						/>
					</div>

					<div>
						<label className="block text-base font-semibold text-[#5a5a5a]">Lastname</label>
						<input
							type="text"
							value={formData.lastname}
							onChange={(event) =>
								onChange({
									...formData,
									lastname: event.target.value,
								})
							}
							className="mt-1 h-11 w-full rounded-sm border border-[#d5d5d5] bg-white px-3 text-base text-[#4E4E4E] outline-none"
							placeholder="กรอกนามสกุล"
						/>
					</div>

					<div>
						<label className="block text-base font-semibold text-[#5a5a5a]">Email</label>
						<input
							type="email"
							value={formData.email}
							onChange={(event) =>
								onChange({
									...formData,
									email: event.target.value,
								})
							}
							className="mt-1 h-11 w-full rounded-sm border border-[#d5d5d5] bg-white px-3 text-base text-[#4E4E4E] outline-none"
							placeholder="กรอกอีเมล"
						/>
					</div>

					<div>
						<label className="block text-base font-semibold text-[#5a5a5a]">Role</label>
						<div className="relative mt-1">
							<select
								value={formData.role}
								onChange={(event) =>
									onChange({
										...formData,
										role: event.target.value as "super_admin" | "admin",
									})
								}
								className="h-11 w-full appearance-none rounded-sm border border-[#d5d5d5] bg-white px-3 pr-10 text-base text-[#4E4E4E] outline-none cursor-pointer"
							>
								{/* <option value="super_admin">Super Admin</option> */}
								<option value="admin">Admin</option>
							</select>
							<MdKeyboardArrowDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-2xl text-[#9a9a9a]" />
						</div>
					</div>
				</div>

				<div className="mt-6 flex justify-end gap-3">
					<button
						type="button"
						onClick={onClose}
						disabled={isSaving}
						className="rounded-md bg-transparent px-3 py-1 text-base font-semibold text-[#1c8bc7] transition hover:underline cursor-pointer"
					>
						ยกเลิก
					</button>
					<button
						type="button"
						onClick={onSave}
						disabled={isSaving}
						className="min-w-24 cursor-pointer rounded-md bg-[#0a9cf0] px-5 py-2 text-base font-semibold text-white hover:bg-[#0784b9] disabled:cursor-not-allowed disabled:opacity-70"
					>
						{isSaving ? "กำลังบันทึก..." : "บันทึก"}
					</button>
				</div>
			</div>
		</div>
	);
}
